import { fetch } from "@/helpers/fetch"; //引用fetch.js

/** 获取商品信息
 * get
 * -------------------------------------传入的参数---------------------------------------------
 * productType   // 秘书 1
 */
export function getOrder(productId,data) {
  return fetch({
    url: '/api/product/'+ productId, 
    method: 'get',
    params: data
  })
}
/** 生成订单
 * get
 * -------------------------------------传入的参数---------------------------------------------
 * productId  订单id
 * userId 订单用户id
 * appId  appId,
 * userType   订单用户来源 0 秘书
 * payPrice  支付金额
 * type   订单来源： 0 pc,1 公众号，2 安卓,3 iso
 */
export function createOrder(data) {
  return fetch({
    url: '/api/order/create',
    method: 'get',
    params: data
  })
}
/** 支付
 * get
 * -------------------------------------传入的参数---------------------------------------------
 * type  //   0 pc,1 公众号，2 安卓,3 iso
 * openid 
 * appId  appId
 */
export function wechatPay(orderId,data) {
  return fetch({
    url: '/api/pay/' + orderId,
    method: 'get',
    params: data
  })
}
/** 查询支付状态接口
 * get
 * -------------------------------------传入的参数---------------------------------------------
 * openid
 * reportId
 */
export function getPayInfo(orderId,data) {
  return fetch({
    url: '/api/pay/' + orderId + '/info',
    method: 'get',
    params: data
  })
}
/** 获取支付成功后的fileUrl
 * get
 * -------------------------------------传入的参数---------------------------------------------
 * openid
 * reportId
 * orderId
 */
export function getFileUrl(data) {
  return fetch({
    url: '/api/wechat/addReportWithOrder',
    method: 'get',
    params: data
  })
}
/** 下载日志收集
 * get
 * -------------------------------------传入的参数---------------------------------------------
 page:(当前页面名)
 type:(操作 wechatdownload / webdownload)
 url:（当前url）
 conent:"reportId的值"
 */
export function getLogs(data) {
  return fetch({
    url: '/api/wechat/logs',
    method: 'post',
	data: data
  })
}

export function getUserCopy(data) {
  return fetch({
    url: '/api/wechat/copyInfoTemplate',
    method: 'get',
    params: data
  })
}

export function getRankList(data) {
  return fetch({
    url: '/api/wechat/getRankInfos',
    method: 'get',
    params: data
  })
}
/**
 * 获得专题接口
 */
export function getTreeDatas(){
  return fetch({
    url: '/api/wechat/warning/subjects',
    method: 'get', 
  })
}
/**
 * 保存专题
 */
export function saveSubject(data) {
  return fetch({
    url: '/api/wechat/subjects',
    method: 'post',
    data: data
  })
}
/**
 * 获得用户信息
 */
export function getUserInfo() {
  return fetch({
    url: '/api/wechat/yqms/userInfo',
    method: 'get'
  })
}